module.exports = __webpack_public_path__ + "static/media/logo_nti_sans_fond-min_225x225.1dfbaf59.png";